"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.groupArray = void 0;
const groupArray = (arr, size) => {
    const nextArr = [];
    if (size === 1) {
        return arr;
    }
    for (let i = 0; i <= Math.ceil(arr.length / size); i += 1) {
        nextArr.push(arr.splice(0, size));
    }
    return nextArr;
};
exports.groupArray = groupArray;
